import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useAnimation, Variants } from "framer-motion";

interface LaserEffectProps {
    duration?: number;
    color?: string;
}

const LaserEffect: React.FC<LaserEffectProps> = ({ color = "#DD0B2F" }) => {
    const [isVisible, setVisible] = useState(true);

    const laserConfigs = [
        { startAngle: -30, endAngle: 30, duration: 1 },
        { startAngle: 30, endAngle: -30, duration: 2 },
        { startAngle: -45, endAngle: 45, duration: 3 },
        { startAngle: 45, endAngle: -45, duration: 1 },
        { startAngle: 0, endAngle: 60, duration: 2 },
    ];

    const laserVariants: Variants = {
        animate: (i: number) => ({
            rotate: [laserConfigs[i].startAngle, laserConfigs[i].endAngle],
            transition: {
                duration: laserConfigs[i].duration,
                repeat: Infinity,
                repeatType: "reverse",
                ease: "linear",
            },
        }),
        pulse: {
            opacity: [1, 0.8, 1],
            scale: [1, 1.02, 1],
            transition: {
                duration: 2,
                repeat: Infinity,
                ease: "linear",
            },
        },
        exit: {
            opacity: 0,
            transition: { duration: 0.5 },
        },
    };

    const laserStyle = {
        background: `linear-gradient(90deg, transparent, ${color}, transparent)`,
        boxShadow: `
       0 0 20px ${color},
        0 0 40px ${color},
        0 0 80px ${color},
        0 0 160px ${color},
        0 0 320px ${color},
        0 0 640px ${color}
    `,
        filter: "brightness(1.5) contrast(1.5) blur(1px)",
    };

    const coreLaserStyle = {
        background: "white",
        boxShadow: `0 0 5px white, 0 0 10px white`,
    };

    useEffect(() => {
        setTimeout(() => {
            setVisible(false);
        }, 5000);
    }, []);

    return (
        <AnimatePresence>
            {isVisible && (
                <div className="pointer-events-none absolute left-0 top-0 h-screen w-screen overflow-hidden bg-redShade-15">
                    {laserConfigs.map((_, index) => (
                        <React.Fragment key={index}>
                            <motion.div
                                className="absolute bottom-0 left-1/2 h-[500%] w-[8px] origin-bottom"
                                style={laserStyle}
                                variants={laserVariants}
                                animate={["animate", "pulse"]}
                                custom={index}
                                exit="exit"
                            />
                            <motion.div
                                className="absolute bottom-0 left-1/2 h-[500%] w-[2px] origin-bottom"
                                style={coreLaserStyle}
                                variants={laserVariants}
                                animate="animate"
                                custom={index}
                                exit="exit"
                            />
                        </React.Fragment>
                    ))}
                </div>
            )}
        </AnimatePresence>
    );
};

export default LaserEffect;
